import Button from '@components/Button';
import SlideBar from '@components/SlideBar';
import usePriceUnit from '@hooks/item/usePriceUnit';
import useShop from '@hooks/shop/useShop';
import useToast from '@hooks/ui/useToast';
import useAppCustom from '@hooks/useAppCustom';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import usePrepareOrder from '@store/order/hooks/usePrepareOrder';
import { orderActions } from '@store/order/orderSlice';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

/** 결제하기 버튼 */
function PurchaseFooter() {
    const { t } = useTranslation('order');
    const toast = useToast();
    const dispatch = useDispatch();
    const prepareOrder = usePrepareOrder();
    const { shopId, cashReceipt, pgAmount } = useCalculatedRequest();
    const shop = useShop(shopId);
    const { paymentButtonType } = useAppCustom().payment;
    const priceUnit = usePriceUnit();

    const handleOrder = () => {
        // 현금영수증 번호는 10자리 이상
        if (cashReceipt && (cashReceipt.issueNumber?.length || 0) < 10) {
            dispatch(orderActions.setCashReceiptError(t('cashReceipt.invalidNumber')));
            return;
        }
        if (pgAmount > 0 && pgAmount < 100) {
            toast.info(t('validation.minPgAmount'));
            return;
        }
        prepareOrder();
    };

    if (shop?.orderStatus !== 'OPEN') {
        return (
            <Button disabled fullWidth>
                {t('footer.preparing')}
            </Button>
        );
    }
    if (paymentButtonType === 'SLIDE') {
        return (
            <SlideBar onConfirm={handleOrder}>
                {t('footer.slidePayment')}
            </SlideBar>
        );
    }
    return (
        <Button onClick={handleOrder} fullWidth>
            {t('footer.paymentWithAmount', { amount: `${pgAmount.toLocaleString()}${priceUnit}` })}
        </Button>
    );
}

export default PurchaseFooter;
